import { render, staticRenderFns } from "./street-manage.vue?vue&type=template&id=3f204c8c&scoped=true&"
import script from "./street-manage.vue?vue&type=script&lang=js&"
export * from "./street-manage.vue?vue&type=script&lang=js&"
import style0 from "./street-manage.vue?vue&type=style&index=0&id=3f204c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f204c8c",
  null
  
)

export default component.exports